export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Учет: Список дел",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
